<script lang="ts">
  import type { ManageAPI } from "~/manage-api/types";
  import type { StoresKey } from "~/stores";
  import { getStoresContext } from "~/stores";
  import { formatDate } from "../../common/date-utils";

  export let event: ManageAPI.Event;
  export let request_store_key: StoresKey;
  
  // Badge styling properties - can be overridden at component level
  export let badgeBackgroundColor: string = "";
  export let badgeTextColor: string = "";
  export let badgeBorderRadius: string = "";

  const { locale, reverse_router } = getStoresContext(request_store_key);


  function getInitial(name: string): string {
    return name?.charAt(0).toUpperCase() || '';
  }

  $: href = $reverse_router.routeEvent(event);
  
  // Build style string for badges using component props or CSS variables
  $: badgeStyle = `
    background-color: ${badgeBackgroundColor || "var(--search-badge-bg-color)"};
    color: ${badgeTextColor || "var(--search-badge-text-color)"};
    border-radius: ${badgeBorderRadius || "var(--search-badge-border-radius)"};
  `;
</script>

<style lang="scss">
  .item-image {
    width: 64px;
    height: 64px;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .logo-fallback {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F5F5F5;
    color: #666;
    font-size: 24px;
    font-weight: 600;
  }

  .item-info {
    flex-grow: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .item-title {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
    letter-spacing: 1px;
    color: var(--search-results-text, #424242);

    &:hover {
      color: var(--search-results-text, #424242);
    }
  }

  .item-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    color: var(--search-results-text, #424242);
  }

  .validity-period {
    font-family: var(--liferay-font-family-base);
    font-size: 14px;
    line-height: 20px;
    color: var(--search-results-text, #424242);
  }

  .meta-tag {
    padding: 2px 8px;
    font-family: var(--liferay-font-family-base);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--search-results-text, #424242);

    &:hover {
      color: var(--search-results-text, #424242);
    }
  }
</style>

<li>
  <a {href} class="event-result">
    <div class="item-image">
      {#if event.images?.[0]}
        <img src={event.images[0]} alt={event.title} />
      {:else}
        <div class="logo-fallback">
          {getInitial(event.title)}
        </div>
      {/if}
    </div>
    <div class="item-info">
      <span class="item-title">{event.title}</span>
      <div class="item-meta">
        <span class="validity-period">
          {formatDate(event.publishDate)}
        </span>
        {#if event.keywords?.[0]}
          <span class="meta-tag" style={badgeStyle}>{event.keywords[0]}</span>
        {/if}
      </div>
    </div>
  </a>
</li> 